import {BuildInfo} from 'appConfig';

// This file is generated by the build process.
export const BUILD_INFO = {
    id:       'bfeYW5LDc6fTT3SB0u59k',
    datetime: '2026-11-04T19:50:16.501Z',
    vcs:      {
        message:   "[HED-930] Add blockchain endpoint of the off-chain backend to cpl-ws",
        datetime:  '2026-11-04T19:50:12.000Z',
        refs:      'HEAD -> feature/HED-930-dex-dyn-update-26-11',
        branch:    'feature/HED-930-dex-dyn-update-26-11',
        revision:  'bf6c7428ea08456d0656e1fab79d6791184b95f3',
        shortHash: 'bf6c7428'
    }
} satisfies BuildInfo;